// TODO: затипизировать

const getOrCreateTooltip = (chart, chartToolTipId) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = chartToolTipId;

    tooltipEl.style =
      // eslint-disable-next-line max-len
      'width: fit-content; padding: 0.875rem; display: flex; align-items: center; position: absolute; transform: translate(-50%, 0); background: #282B3D; border-radius: 0.3536rem; pointer-events: none; border: 0.0625rem solid #5F5F5F;';

    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context, title, chartToolTipId, isMobile = false) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart, chartToolTipId);

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    let textLeftBlock = chart.canvas.parentNode.querySelector('div');
    let rightDiv = chart.canvas.parentNode.querySelector('div');
    let pointer = chart.canvas.parentNode.querySelector('div');

    const value = tooltip.body.map(b => b.lines)[0];

    const tooltipRoot = document.getElementById(chartToolTipId);

    while (tooltipRoot?.firstChild) {
      tooltipRoot.firstChild.remove();
    }

    textLeftBlock = document.createElement('div');
    pointer = document.createElement('div');
    textLeftBlock.style =
      /* isMobile
      ? 'font-weight: 700; font-size: 0.75rem; margin-right: 0.625rem; display: flex; align-items: center'
      :  */ 'font-weight: 700; font-size: 0.75rem; margin-right: 6.25rem; display: flex; align-items: center';
    pointer.style =
      'background: linear-gradient(180deg, #FFF09D 0%, #FFCB3C 100%); width: 0.875rem; min-width: 0.875rem; height: 0.875rem; border-radius: 50%; margin-right: 0.625rem';

    const textLeft = document.createTextNode(title);
    textLeftBlock.appendChild(pointer);
    textLeftBlock.appendChild(textLeft);
    const { format } = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
    });
    const parsedValue = value[0].split(',').join('');
    const numberValue = Number(parsedValue);

    const formattedValue = Number.isNaN(numberValue) ? value[0] : format(numberValue);
    const textRight = document.createTextNode(formattedValue);

    const leftDiv = document.createElement('div');
    rightDiv = document.createElement('div');

    rightDiv.style = 'font-weight: 700; font-size: 0.75rem';

    leftDiv.appendChild(textLeftBlock);
    rightDiv.appendChild(textRight);
    tooltipEl.appendChild(leftDiv);
    tooltipEl.appendChild(rightDiv);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  tooltipEl.style.opacity = 1;
  /* tooltipEl.style.left = `${positionX + tooltip.caretX}px`; */
  tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
  tooltipEl.style.font = tooltip.options.bodyFont.string;

  // что бы тултип не вылезал за границы канваса
  if (tooltip.x + tooltipEl.offsetWidth > chart.canvas.offsetWidth) {
    tooltipEl.style.left = `auto`;
    tooltipEl.style.right = `0px`;
    tooltipEl.style.transform = `none`;
  } else if (tooltip.x - tooltipEl.offsetWidth / 2 < 0) {
    tooltipEl.style.right = `auto`;
    tooltipEl.style.left = `0px`;
    tooltipEl.style.transform = `none`;
  } else {
    tooltipEl.style.right = `auto`;
    tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
    tooltipEl.style.transform = `translate(-50%, 0)`;
  }
};
